import React from "react";
import { FormControl, FormHelperText, IconButton, Input, InputAdornment, InputLabel,useTheme } from "@mui/material";
import { Search, Clear, Add, } from "@mui/icons-material";
import { FieldRenderProps } from "react-final-form";

interface PropsTextSearchSelect {
    formProps: FieldRenderProps<any, HTMLElement>
    onClickButton(): void
    label: string;
    showButtonLimpar: boolean;
    showNewButton: boolean;
    handleNewButton?: () => void;
    handleButtonLimpar?: () => void;
    handleMutator?: (value: any, field: any) => void;
}
export default function TextSearchSelect(props: PropsTextSearchSelect) {
    const { formProps, onClickButton, label, showButtonLimpar, handleButtonLimpar, showNewButton, handleNewButton } = props;
    return (
        <FormControl fullWidth>
            <InputLabel>{label}</InputLabel>
            <Input
                value={formProps.input.value}
                onChange={formProps.input.onChange}
                onBlur={formProps.input.onBlur}
                error={formProps.meta.error && formProps.meta.touched}                
                disabled
                startAdornment={
                    showNewButton && (
                        <InputAdornment position="start">
                            <IconButton onClick={handleNewButton} title="Adicionar">
                                <Add />
                            </IconButton>
                        </InputAdornment>

                    )
                }
                endAdornment={
                    <>
                        {formProps.input.value && showButtonLimpar ? (
                            <InputAdornment position="start">
                                <IconButton onClick={handleButtonLimpar} title="Limpar">
                                    <Clear />
                                </IconButton>
                            </InputAdornment>

                        ) : null}
                        <InputAdornment position="end">
                            <IconButton onClick={onClickButton} title="Localizar">
                                <Search />
                            </IconButton>
                        </InputAdornment>
                    </>
                }
            />
            <FormHelperText color="red" >{formProps.meta.touched ? formProps.meta.error : null}</FormHelperText>
        </FormControl>
    )
}